import { Occ } from '@spartacus/core';
import { Observable } from 'rxjs';
import { InstallmentPayments } from '../../model/gg-payment.model';
import { RedirectURL } from './payment.connector';

export abstract class PaymentAdapter {
  abstract addSelected(userId: string, cartId: string, selectedPayment: string): Observable<Occ.PaymentDetails>;
  abstract getSelected(userId: string, cartId: string): Observable<string>;
  abstract nestpayAuthorization(userId: string, cartId: string): Observable<string>;
  abstract klarna(userId: string, cartId: string): Observable<string>;
  abstract megapos(userId: string, cartId: string): Observable<string>;
  abstract stripe(userId: string, cartId: string): Observable<string>;
  abstract monri(userId: string, cartId: string): Observable<string>;
  abstract simplepay(userId: string, cartId: string): Observable<string>;
  abstract gpwebpay(userId: string, cartId: string): Observable<RedirectURL>;
  abstract leanpay(userId: string, cartId: string): Observable<string>;
  abstract payway(userId: string, cartId: string): Observable<string>;
  abstract getInstallmentPayments(paymentMethod: string, price: number): Observable<InstallmentPayments>;
  abstract paypal(userId: string, cartId: string): Observable<string>;
}
